import React, { useRef, useState, useEffect } from 'react';
import Select from 'react-select';
import { Col, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDispatch, useSelector } from 'react-redux';
import { useManualState } from './Provider';
import Loader from '../../Components/Utility/Loader/Loader';
import DocumentTabel from './DocumentTabel';
import UploadDocument from './uploadDocument';
import UploadFolder from './uploadFolder';
import * as action from './store/Document.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import DocumentFilter from './DocumentFilter';
import { SearchIcon, AddIcon, MoveIcon, DeleteIcon, ArchiveIcon } from '../../bombiix-icon';
import './Document.css';

function Document() {
  const { state, setState, apiCallWithFilter, isSupplierLoggedIn, manualAddEditAccess, manualDeleteAccess } = useManualState();
  const { t } = useTranslation('common');
  const expandSearchRefBin = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [openFolderModal, setFolderOpenModal] = useState(false);
  const dispatch = useDispatch();
  const {
    DocumentReducer: { ListData, totalCount, crumbData, getAllFolderList },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    return () => {
      setState((prev) => ({
        ...prev,
        documentList: [],
        pageIndex: 1,
        hasMore: false,
        searchText: '',
        breadCrumbData: [],
      }));
      dispatch(action.clearReducer());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (crumbData?.length > 0) {
      setState((prev) => ({
        ...prev,
        breadCrumbData: crumbData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crumbData]);

  useEffect(() => {
    if (ListData.length > 0) {
      setState((nextPagestate) => ({
        ...nextPagestate,
        documentList: ListData,
        hasMore: totalCount > ListData.length,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ListData, totalCount]);

  const handleNextPagesInScroll = async () => {
    const documentData = JSON.parse(localStorage.getItem('manualDoumentFolder')) || {};
    let folderId = null;
    if (documentData?._id) {
      folderId = documentData?._id;
    }
    let pageIndex = state?.pageIndex;
    pageIndex += 1;
    setState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      isPageLoader: true,
    }));
    const params = {
      pageIndex,
      pageSize: state?.pageSize,
      folderId,
      isArchived: state?.isArchived,
    };

    const res = await dispatch(action.getManualDocumentList(params));
    if (res) {
      setState((prevState) => ({
        ...prevState,
        isPageLoader: false,
      }));
    }
  };

  const onRenew = async (item) => {
    await dispatch(action.getDocumentDataById(item?._id));
    setOpenModal(true);

    setState((prevState) => ({
      ...prevState,
      isFromRenew: true,
    }));
  };

  const handleSelect = (name) => {
    setState((prevState) => ({
      ...prevState,
      selectedOption: name,
    }));
    if (name === 'upload') {
      setOpenModal(true);
    } else {
      setFolderOpenModal(true);
    }
  };

  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };

  const handleTemplateSearch = (value) => {
    setState((prev) => ({
      ...prev,
      searchText: value,
      searchLoaded: true,
    }));
  };

  const getDocumentList = async (fromArchieve) => {
    let folderId = null;
    setState((prev) => ({
      ...prev,
      breadCrumbData: [],
    }));
    if (fromArchieve) {
      localStorage.removeItem('manualDoumentFolder');
    } else {
      const documentData = JSON.parse(localStorage.getItem('manualDoumentFolder')) || {};
      if (documentData?._id) {
        await dispatch(action.getBreadCrumbDocumentData(documentData?._id));
        folderId = documentData?._id;
      }
    }

    setState((nextPagestate) => ({
      ...nextPagestate,
      loading: true,
      documentList: [],
    }));
    await dispatch(action.clearReducer());

    const localstorageFilter = JSON.parse(localStorage.getItem('documentsFilter'));

    if (
      localstorageFilter &&
      (localstorageFilter?.brand?.length ||
        localstorageFilter?.suppliers?.length ||
        localstorageFilter?.documentFilterType ||
        localstorageFilter?.startDate ||
        localstorageFilter?.endDate)
    ) {
      apiCallWithFilter(localstorageFilter, folderId, fromArchieve);
    } else {
      const params = {
        pageIndex: 1,
        pageSize: state?.pageSize,
        folderId,
        isArchived: fromArchieve ? !state?.isArchived : state?.isArchived,
      };

      const res = await dispatch(action.getManualDocumentList(params));
      if (res) {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          pageIndex: 1,
        }));
      }
    }
  };

  const EditDocumentOpenClose = () => {
    setOpenModal(!openModal);
    setState((prevState) => ({
      ...prevState,
      selectedOption: null,
      isEditFile: false,
      isFromRenew: false,
    }));
    getDocumentList();
  };

  const EditFolderOpenClose = () => {
    setFolderOpenModal(!openFolderModal);
    setState((prevState) => ({
      ...prevState,
      selectedOption: null,
      isEditFolder: null,
    }));
    getDocumentList();
  };

  const handleDeleteMultiple = (id) => {
    if (id) {
      setState((prevState) => ({
        ...prevState,
        deleteId: id,
      }));
    }
    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: true,
    }));
  };

  const handleConfirmDelete = async () => {
    const params = {
      deleteIds: state?.deleteId ? [state?.deleteId] : state?.selectedIds,
    };

    let res = false;
    if (state?.deleteId || state?.selectedIds?.length > 0) {
      setState((prevState) => ({
        ...prevState,
        loading: true,
        documentList: [],
      }));
      res = await dispatch(action.MultiDeleteManualDocuemnt(params, t));
    }

    if (res) {
      dispatch(action.clearReducer());
      setState((prevState) => ({
        ...prevState,
        selectedIds: [],
        deleteId: null,
        loading: false,
      }));

      getDocumentList();
    }

    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: false,
    }));
  };

  const handleFolderClick = async (item, fromParent) => {
    if (state.isLoading) return; // Prevent multiple clicks

    setState((prev) => ({
      ...prev,
      isLoading: true, // Set loading state to true
      breadCrumbData: [],
    }));

    try {
      if (fromParent) {
        localStorage.removeItem('manualDoumentFolder');
        await dispatch(action.getBreadCrumbDocumentData(null));
      } else {
        localStorage.setItem('manualDoumentFolder', JSON.stringify(item));
        await dispatch(action.getBreadCrumbDocumentData(item?._id));
      }

      dispatch(action.clearReducer());

      setState((prev) => ({
        ...prev,
        documentList: [],
        pageIndex: 1,
        searchText: '',
        selectedDocumentId: null,
        selectedIds: [],
      }));

      const localstorageFilter = JSON.parse(localStorage.getItem('documentsFilter'));

      if (
        localstorageFilter &&
        (localstorageFilter?.brand?.length ||
          localstorageFilter?.suppliers?.length ||
          localstorageFilter?.documentFilterType ||
          localstorageFilter?.startDate ||
          localstorageFilter?.endDate)
      ) {
        await apiCallWithFilter(localstorageFilter, item?._id || null); // Ensure this is awaited
      } else {
        const obj = {
          pageIndex: 1,
          pageSize: state?.pageSize,
          folderId: item?._id || null,
          isArchived: state?.isArchived,
        };
        await dispatch(action.getManualDocumentList(obj)); // Ensure this is awaited
      }
    } catch (error) {
      console.error('Error handling folder click:', error);
    } finally {
      setState((prev) => ({
        ...prev,
        isLoading: false, // Reset loading state
      }));
    }
  };

  const handleArchievDocument = () => {
    setState((prev) => ({
      ...prev,
      isArchived: !state?.isArchived,
      searchText: '',
      loading: true,
    }));
    getDocumentList('fromArchieve');
  };

  const handleArchiveCard = (id) => {
    setState((prev) => ({
      ...prev,
      showArchivePopup: true,
      archivedId: id,
    }));
  };

  const toggleArchive = () => {
    setState((prev) => ({
      ...prev,
      loading: false,
      showArchivePopup: false,
      archivedId: null,
      archiveComment: '',
      title: '',
      selectedIds: [],
    }));
  };

  const conformArchive = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));

    const archiveCardDetails = {
      archiveState: !state?.isArchived,
      archiveComment: state?.isArchived ? '' : state?.archiveComment,
      fileIds: state?.archivedId ? [state?.archivedId] : state?.selectedIds,
    };
    const res = await dispatch(action.archiveUnarchiveDocument({ ...archiveCardDetails }, t));

    if (res) {
      toggleArchive();
      getDocumentList();
    }
  };

  const archiveCommentChanges = (e) => {
    setState((prev) => ({
      ...prev,
      archiveComment: e?.target?.value,
    }));
  };

  const moveDocumentToFolder = async (eleItem) => {
    const documentData = JSON.parse(localStorage.getItem('manualDoumentFolder')) || {};
    await dispatch(action.getAllFolderList({ id: documentData?._id ? documentData?._id : null }));
    setState((nextPagestate) => ({
      ...nextPagestate,
      selectedDocumentId: eleItem?._id,
      isFolderPopup: true,
    }));
  };

  const moveDocumentFolderToFolder = async () => {
    const documentData = JSON.parse(localStorage.getItem('manualDoumentFolder')) || {};
    await dispatch(action.getAllFolderList({ id: documentData?._id ? documentData?._id : null }));
    setState((nextPagestate) => ({
      ...nextPagestate,
      selectedDocumentId: null,
      isFolderPopup: true,
    }));
  };

  const closePopup = () => {
    setState((nextPagestate) => ({
      ...nextPagestate,
      selectedFolder: null,
      selectedDocumentId: null,
      isFolderPopup: false,
      selectedIds: [],
    }));
  };

  const setSelectedFolder = async (e) => {
    setState((prev) => ({
      ...prev,
      selectedFolder: e.value,
    }));
    const obj = {
      folderId: e.value === 'home' ? '' : e.value,
      srcId: state?.selectedDocumentId ? state?.selectedDocumentId : state?.selectedIds,
    };

    const res = await dispatch(action.moveDocumentToFolder(obj, t));
    if (res?.code === 200) {
      getDocumentList();
      closePopup();
    }
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('MANUAL_DOCUMENTS.MANUAL_DOCUMENTS')}</h4>
        </div>
        <div className="search-filter action-icons-container care-library-filter">
          <div ref={expandSearchRefBin} className="common-expand-search">
            <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
              <span className="sr-only ">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH USER_INSTRUCTION')}</span>
              {/* 16, not 24: .common-expand-search .btn.btn-toggle is absolutely positioned with
                  6px padding and the expanded input reserves only 29px, so a larger glyph
                  overlaps the placeholder. */}
              <SearchIcon size={16} />
            </button>
            <input
              type="text"
              className="form-control"
              value={state?.searchText}
              onChange={(e) => handleTemplateSearch(e.target.value)}
              autoComplete="off"
              placeholder="Search"
            />
          </div>
          <DocumentFilter />
          {!isSupplierLoggedIn && (
            <button
              type="button"
              className="cursor-pointer text-dark text-bold text-decoration-none f-14 group-btn btn mb-0"
              onClick={() => handleArchievDocument()}
            >
              {state?.isArchived ? 'Open' : 'Archived'}
            </button>
          )}
        </div>
      </div>
      {!isSupplierLoggedIn && (
        <div className="floting-actions">
          {!state?.isArchived && manualAddEditAccess && (
            <>
              <CustomTooltip placement="left" tooltipText={t('CARE_LABELS.LIBRARY_FILTER.ADD')}>
                <button aria-label="Add" type="button" className="btn d-inline-flex p-0">
                  <OverlayTrigger
                    placement="top"
                    trigger="click"
                    rootClose
                    overlay={
                      <Popover className="custom-popover file-download-popover">
                        <Popover.Content>
                          <ul>
                            <li className="p-0">
                              <button className="p-0 f-16 add-option text-medium btn" type="button" onClick={() => handleSelect('folder')}>
                                {t('MANUAL_DOCUMENTS.CREATE_FOLDER')}
                              </button>
                            </li>
                            <li className="p-0">
                              <button className="p-0 f-16 add-option text-medium btn" type="button" onClick={() => handleSelect('upload')}>
                                {t('MANUAL_DOCUMENTS.UPLOAD_DOCUMENT')}
                              </button>
                            </li>
                          </ul>
                        </Popover.Content>
                      </Popover>
                    }
                  >
                    <span className="d-inline-flex"><AddIcon size={24} /></span>
                  </OverlayTrigger>
                </button>
              </CustomTooltip>

              <CustomTooltip placement="left" tooltipText={t('MANUAL_DOCUMENTS.MOVE')}>
                <button
                  disabled={!state?.selectedIds?.length > 0}
                  aria-label="Move Document"
                  type="button"
                  className="btn d-inline-flex p-0"
                  onClick={() => moveDocumentFolderToFolder()}
                >
                  <OverlayTrigger
                    placement="top"
                    trigger="click"
                    rootClose
                    overlay={
                      <Popover className="custom-popover file-download-popover">
                        <Popover.Content>
                          <div className="common-react-select mb-0">
                            <Select
                              id="folderSelect"
                              className="common-select"
                              classNamePrefix="common-select"
                              options={[
                                ...(state?.breadCrumbData?.length > 0 ? [{ value: 'home', label: 'Home' }] : []), // Add "Home" only if breadCrumbData has items
                                ...getAllFolderList
                                  .filter((re) => !state?.selectedIds?.includes(re?._id))
                                  .map((folder) => ({
                                    value: folder._id,
                                    label: folder.documentTitle,
                                  })),
                              ]}
                              menuPlacement="top"
                              value={
                                state?.selectedFolder
                                  ? {
                                      value: state?.selectedFolder,
                                      label:
                                        state?.selectedFolder === 'home'
                                          ? 'Home'
                                          : getAllFolderList.find((folder) => folder._id === state?.selectedFolder)?.documentTitle,
                                    }
                                  : null
                              }
                              onChange={(selectedOption) => setSelectedFolder(selectedOption)}
                              placeholder="Select Folder"
                            />
                          </div>
                        </Popover.Content>
                      </Popover>
                    }
                  >
                    <span className="d-inline-flex"><MoveIcon size={24} /></span>
                  </OverlayTrigger>
                </button>
              </CustomTooltip>
            </>
          )}
          {manualDeleteAccess && (
            <CustomTooltip placement="top" tooltipText={t('COLOR_WAY_CARD.DELETE')}>
              <button
                type="button"
                aria-label={t('COMMON_LABEL.DELETE')}
                onClick={() => handleDeleteMultiple(state?.deleteId)}
                className="btn"
                disabled={!state?.selectedIds?.length > 0}
              >
                <DeleteIcon size={24} />
              </button>
            </CustomTooltip>
          )}
          {state?.isArchived && manualAddEditAccess && (
            <CustomTooltip placement="top" tooltipText="Unarchive">
              <button
                type="button"
                aria-label="Archive"
                onClick={() => handleArchiveCard(state?.archivedId)}
                className="btn"
                disabled={!state?.selectedIds?.length > 0}
              >
                <ArchiveIcon size={24} />
              </button>
            </CustomTooltip>
          )}
        </div>
      )}
      <div className="container-fluid manual-container mt-24">
        <div className="d-flex mb-16 align-items-end">
          {!state?.isArchived && (
            <button type="button" className="btn d-inline-flex p-0" aria-label="button" onClick={() => handleFolderClick(null, true)}>
              <i className="icon-Home text-black f-28" />
            </button>
          )}
          {state?.breadCrumbData?.length > 0 &&
            state?.breadCrumbData?.map((re, index) => (
              <span className="f-16 text-underline cursor-pointer ml-16 text-bold" key={index} onClick={() => handleFolderClick(re)}>
                {re?.name}
              </span>
            ))}
        </div>
        <Row>
          {state.loading ? (
            <Loader />
          ) : (
            <Col lg="12">
              <div id="scrollableDiv" className="table-responsive table-max-h-50" style={{ minHeight: '200px' }}>
                <InfiniteScroll
                  dataLength={state.documentList.length}
                  next={() => {
                    handleNextPagesInScroll();
                  }}
                  hasMore={state.hasMore}
                  loader={state.isPageLoader && <Loader />}
                  scrollableTarget="scrollableDiv"
                >
                  <DndProvider backend={HTML5Backend}>
                    <DocumentTabel
                      handleDeleteMultiple={handleDeleteMultiple}
                      handleArchiveCard={handleArchiveCard}
                      onRenew={onRenew}
                      moveDocumentToFolder={moveDocumentToFolder}
                      getDocumentList={getDocumentList}
                      setFolderOpenModal={setFolderOpenModal}
                      setOpenModal={setOpenModal}
                      isArchived={state?.isArchived}
                    />
                  </DndProvider>
                </InfiniteScroll>
              </div>
            </Col>
          )}
        </Row>
      </div>
      {openModal && <UploadDocument onOpen={openModal} toggle={EditDocumentOpenClose} />}
      {openFolderModal && <UploadFolder onOpen={openFolderModal} toggle={EditFolderOpenClose} />}
      {state?.showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={state?.showConfirmationPopup}
          toggle={() =>
            setState((prevState) => ({
              ...prevState,
              showConfirmationPopup: !state?.showConfirmationPopup,
              deleteId: '',
              selectedIds: [],
            }))
          }
          id={state?.deleteId}
          onConfirm={handleConfirmDelete}
          title="Delete"
          message="Are you sure you want to delete the selected document?"
        />
      )}
      {state?.showArchivePopup && (
        <ConfirmationPopup
          onOpen={state?.showArchivePopup}
          onConfirm={conformArchive}
          title={`${state?.isArchived ? t('PARTNER_OVERVIEW.UNARCHIVE') : t('PARTNER_OVERVIEW.ARCHIEVE')} Document`}
          message={`Are you sure you want to ${state?.isArchived ? t('PARTNER_OVERVIEW.unarchive') : t('PARTNER_OVERVIEW.archive')} the selected document?`}
          secondMessage={state?.isArchived && t('PARTNER_OVERVIEW.UNARCHIVE_MESSAGE')}
          toggle={toggleArchive}
          isCommentOn={!state?.isArchived}
          commentText={archiveCommentChanges}
          comment={state?.archiveComment}
          showCommentHeader
          fromSupplier
        />
      )}
    </>
  );
}

export default Document;
